import config from 'configDir/index';
import { get } from './http';

// 安全分析相关
// 查询安全分数同比使用
const safetyScoreGetListForComparedService = get(
  '/safetyScore/getListForCompared',
  config.commonServiceUrl,
);

// 查询安全分数同比使用（新版）
const newSafetyScoreGetListForComparedService = get(
  '/safetyScore/new/getListForCompared',
  config.commonServiceUrl,
);
// 查询安全分数统计表格
const safetyScoreGetListForStatisticsService = get(
  '/safetyScore/getListForStatistics',
  config.commonServiceUrl,
);
// 查询安全分数统计表格(新版)
const newSafetyScoreGetListForStatisticsService = get(
  '/safetyScore/new/getListForStatistics',
  config.commonServiceUrl,
);
// 查询安全分数企业排名
const safetyScoreGetRankService = get('/safetyScore/getRank', config.commonServiceUrl);

// 查询安全分数企业排名(新版)
const newSafetyScoreGetRankService = get('/safetyScore/new/getRank', config.commonServiceUrl);
export {
  safetyScoreGetListForComparedService,
  safetyScoreGetListForStatisticsService,
  safetyScoreGetRankService,
  newSafetyScoreGetListForStatisticsService,
  newSafetyScoreGetListForComparedService,
  newSafetyScoreGetRankService,
};
